import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import { RequireAuth } from "../../authorize/requireAuth";

const InvestmentReportListPage = React.lazy(() => import("./InvestmentReportListPage"));
const InvestmentReportEditor = React.lazy(() => import("./InvestmentReportEditor"));

export const useInvestmentReportRoutes = () => (
  <React.Fragment>
    <Route
      path="investmentReport"
      element={
        <RequireAuth policies={["InvestmentMonthlyPerformance-Update"]} redirect={true}>
          <Suspense fallback={<div>منتظر باشید...</div>}>
            <InvestmentReportListPage />
          </Suspense>
        </RequireAuth>
      }
    />
    <Route
      path="investmentReport/new"
      element={
        <RequireAuth
          policies={["InvestmentMonthlyPerformance-Scrap", "InvestmentMonthlyPerformance-Update"]}
          redirect={true}>
          <Suspense fallback={<div>منتظر باشید...</div>}>
            <InvestmentReportEditor />
          </Suspense>
        </RequireAuth>
      }
    />
  </React.Fragment>
);
